export default "__VITE_ASSET__DaA52uTN__"